import { Handle, Position, type NodeProps } from "@xyflow/react";

import type { BrainFlowNodeData } from "../brainToFlow";

export default function BrainHubNode({ data }: NodeProps) {
  const d = data as BrainFlowNodeData;
  return (
    <div className="nopan flex max-w-[160px] items-center justify-center rounded-full bg-slate-800 px-4 py-3 text-center shadow-md">
      <Handle type="source" position={Position.Right} className="!opacity-0" />
      <Handle type="source" position={Position.Left} className="!opacity-0" />
      <Handle type="source" position={Position.Top} className="!opacity-0" />
      <Handle type="source" position={Position.Bottom} className="!opacity-0" />
      <span className="text-xs font-semibold leading-snug text-white">{d.label}</span>
    </div>
  );
}
